import { render } from "./ActivityMessage.vue?vue&type=template&id=23e899be&scoped=true&ts=true"
import script from "./ActivityMessage.ts?vue&type=script&lang=ts"
export * from "./ActivityMessage.ts?vue&type=script&lang=ts"

import "./ActivityMessage.scss?vue&type=style&index=0&id=23e899be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e899be"]])

export default __exports__